import type { HelpFile } from '../../types/help'
import { AutoAssignRuleRequestsTestIds } from '../../../testids/AutoAssignRuleRequestsTestIds'

export const autoAssignRuleRequestsHelp: HelpFile = {
  docPage: '/docs/governance/auto-assign-rules',
  texts: {
    [AutoAssignRuleRequestsTestIds.autoAssignRuleRequestsList]:
      'Rule requests are change proposals for auto-assign rules — create, edit, and submit rules for approval before they take effect.',
    [AutoAssignRuleRequestsTestIds.btnCreateRequest]:
      'Open the wizard to propose a new auto-assign rule.',
    [AutoAssignRuleRequestsTestIds.colRequestType]:
      'Whether the request creates, edits, or removes an auto-assign rule.',
  },
}
